/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Charging Icon component.
 */
export const ChargingIcon = ({
  size = 12,
  color = dlsColor('caGreen')
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({size, color});

  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 12 12' fill='none'>
      <path d='M 1.3333 6.6668 C 1.3333 5.9334 1.9333 5.3334 2.6667 5.3334 H 3.6667 C 4.9533 5.3334 6 4.2867 6 3.0001 C 6 1.7134 4.9533 0.6667 3.6667 0.6667 H 1.3333 C 0.9667 0.6667 0.6667 0.9667 0.6667 1.3334 C 0.6667 1.7001 0.9667 2.0001 1.3333 2.0001 H 3.6667 C 4.22 2.0001 4.6667 2.4468 4.6667 3.0001 C 4.6667 3.5534 4.22 4.0001 3.6667 4.0001 H 2.6667 C 1.1933 4.0001 0 5.1934 0 6.6668 C 0 8.1401 1.1933 9.3334 2.6667 9.3334 H 4 V 8.0001 H 2.6667 C 1.9333 8.0001 1.3333 7.4001 1.3333 6.6668 Z' fill={iconColor} />
      <path d='M 6.0003 7.3333 H 4.667 V 10 H 6.0003 C 6.0003 10.7333 6.6003 11.3333 7.3337 11.3333 H 9.3337 V 6 H 7.3337 C 6.6003 6 6.0003 6.6 6.0003 7.3333 Z' fill={iconColor} />
      <path d='M 12 7.3334 C 12 6.9667 11.7 6.6667 11.3333 6.6667 H 10 V 8.0001 H 11.3333 C 11.7 8.0001 12 7.7001 12 7.3334 Z' fill={iconColor} />
      <path d='M 11.3333 9.3335 H 10 V 10.6668 H 11.3333 C 11.7 10.6668 12 10.3668 12 10.0002 C 12 9.6335 11.7 9.3335 11.3333 9.3335 Z' fill={iconColor} />
    </svg>
  );
};
